export default class Option {
  private _key: string
  private _label: string

  constructor ({ key, label }: { key: string; label: string }) {
    this._key = key
    this._label = label
  }

  get key (): string {
    return this._key
  }

  get label (): string {
    return this._label
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/bottts/options/Option.ts